import { render, staticRenderFns } from "./LightboxWagtailPage.vue?vue&type=template&id=5bd60b41&scoped=true"
import script from "./LightboxWagtailPage.vue?vue&type=script&lang=js"
export * from "./LightboxWagtailPage.vue?vue&type=script&lang=js"
import style0 from "./LightboxWagtailPage.vue?vue&type=style&index=0&id=5bd60b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd60b41",
  null
  
)

export default component.exports